import React, { useMemo, memo } from 'react';
import {
    Box,
    Checkbox,
    Stack,
    Text,
} from '@chakra-ui/react';

const MultiSelectClass = memo(({
    options = [], // [{id, name}]
    value = [], // [id, id]
    onChange, // (newValues) => {}
    placeholder = "選擇班級"
}) => {

    // Deduplicate options using Map (safer than Set filter)
    const uniqueOptions = useMemo(() => {
        if (!options) return [];
        return Array.from(new Map(options.map(item => [item.id, item])).values());
    }, [options]);

    const handleToggle = (id) => {
        // Robust check converting to string for comparison
        const strId = String(id);
        const isSelected = value.some(v => String(v) === strId);

        let newValues;
        if (isSelected) {
            // Remove
            newValues = value.filter(v => String(v) !== strId);
        } else {
            // Add
            newValues = [...value, id];
        }

        console.log(`[MultiSelect] Toggle ID: ${id} | Was Selected: ${isSelected} | New Values:`, newValues);
        onChange(newValues);
    };

    return (
        <Box
            borderWidth="1px"
            borderRadius="md"
            borderColor="gray.200"
            p={3}
            maxH="200px"
            overflowY="auto"
            bg="white"
            w="100%"
        >
            <Stack spacing={2}>
                {uniqueOptions.map(opt => {
                    const isChecked = value.some(v => String(v) === String(opt.id));
                    return (
                        <Checkbox
                            key={opt.id}
                            id={`class-checkbox-${opt.id}`}
                            isChecked={isChecked}
                            onChange={() => handleToggle(opt.id)}
                            colorScheme="brand"
                        >
                            {opt.name}
                        </Checkbox>
                    );
                })}

                {uniqueOptions.length === 0 && (
                    <Text color="gray.500" fontSize="sm" textAlign="center">
                        無班級可選
                    </Text>
                )}
            </Stack>
        </Box>
    );
});

export default MultiSelectClass;
